import axios from "axios";
import { getOneRosterFileApiBaseUrl } from "./constants";

type GetOneRosterJobParams = {
  returnJobStatus?: boolean;
};

export const getOneRosterJob = async (param: GetOneRosterJobParams = {}) => {
  try {
    const res = await axios.get(`${getOneRosterFileApiBaseUrl()}/oneroster/job/latest/status`, {
      withCredentials: true,
    });
    if (param?.returnJobStatus) {
      return res;
    }
    let dataJsonFile: any;
    if (res.data.status === 'COMPLETED') {
      dataJsonFile = res.data.presignedUrl;
      const response = await axios.get(dataJsonFile);
      return response;
    } else {
      throw new Error('OneRoster job is not completed');
    }
  } catch (error: any) {
    throw new Error('Error fetching OneRoster job data');
  }
};
